module.exports = __webpack_public_path__ + "img/ic-lopen.ed9e1886.svg";